module.exports = "/assets/site/images/MVM_tura.jpg?eabf9d8bf7f23b4057d8e7d51ae2b518";